/*
 * @Author: songxiaoqiang
 * @Date: 2020-08-10 11:33:26
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import "../../../utils/sa.js";
import Aegis from 'aegis-web-sdk';

const aegis = new Aegis({   
    id: 'vq6qDu47L2vRo3l8XD', //应用ID，即上报key   
    uin: '', // 用户唯一 ID（可选）    
    reportApiSpeed: true, // 接口测速    
    reportAssetSpeed: false, // 静态资源测速    
    spa: true // spa 应用页面跳转的时候开启 pv 计算
})

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./templates/luodiye/src/index.js